
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { get } from "lodash";
import { FeaturesList, UserPermissions } from "@/store/types";
import GenericAdvancedTooltip from "../generic-advanced-tooltip/GenericAdvancedTooltip.vue";
import EventLinkWrapper from "@/components/event-links/EventLinkWrapper.vue"

const BUTTON_PRIMARY = "primary";
const BUTTON_SECONDARY = "secondary";

@Component({
	components: {
    	"generic-advanced-tooltip": GenericAdvancedTooltip,
		"link-event-wrapper": EventLinkWrapper,
	}
})

export default class EventLinkToolTipAndButton extends Vue {
	@Getter("getFeaturesList") featuresList!: FeaturesList;
	@Getter getPermissions: UserPermissions;

	@Prop(Number) readonly eventId: number;

	private showTooltip: boolean = false;

	private toggleShowTooltip(): void {
		this.showTooltip = !this.showTooltip;
	}

	private get isLinkEventsEnabled(): boolean {
		return get(this.featuresList, ["Alarms", "EventSearch", "EventLinks"]);
	}

	private get buttonVariant(): string {
        return this.showTooltip ? BUTTON_PRIMARY : BUTTON_SECONDARY;
    }

	private get canEditEventLinks(): boolean {
		return get(this.featuresList, ["Alarms", "EventSearch", "EventLinks"]) && this.getPermissions.canEditEventLink;
	}
}

